export const LeftArrow = () => {
  return (
    <svg
      className="size-4"
      fill="none"
      height="14"
      viewBox="0 0 15 14"
      width="15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.188 5.448V8.304H0.028V5.448H11.188ZM4.588 13.056L10.756 6.888L4.588 0.719999H8.596L14.764 6.888L8.596 13.056H4.588Z"
        fill="white"
      />
    </svg>
  );
};
